<div nz-row style="margin-bottom: 10px;">
  <div nz-col nzSpan="12">
    <span class="header-avatar" >Welcome! {{user.User_Name}}</span>    
  </div>
  <div nz-col nzSpan="12">
    <!-- <div nz-col style="float: right;" >
    
      <nz-avatar [nzSize]="35" [nzSrc]="userPhoto"
          style="margin-left:2px;"></nz-avatar>
    </div>  -->
    <div nz-col style="float: right;text-align: right;" >
      <span class="header-avatar" >Roles - [{{user.Roles}}]</span>
      <br *ngIf="isDisplaySessionTimer" />
      <span *ngIf="isDisplaySessionTimer"  class="header-avatar" style="color: dimgray; font-size: 80%;">Session Expires In: {{ timeLeft }}</span>
    </div> 
  </div>
  
</div>
  
  


